import { render, staticRenderFns } from "./LightbulbIcon.vue?vue&type=template&id=701b6c43&"
import script from "./LightbulbIcon.vue?vue&type=script&lang=js&"
export * from "./LightbulbIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports